<template>
  <BModal
    id="modal-topup"
    ref="modal-topup"
    no-stacking
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    @show="onShow"
  >
    <BRow class="justify-center my-1 flex flex-column">
      <BCol class="d-flex justify-content-center">
        <strong class="text-black text-xl">
          Top Up Komcards
        </strong>
      </BCol>
      <BCol class="d-flex justify-content-center my-1">
        <div class="text-black text-md">
          {{ cardData.name }} {{ (cardData.card_number) }}
        </div>
      </BCol>
      <BCol class="justify-content-center">
        <ValidationObserver #default="{ invalid }">
          <BFormGroup>
            <template #label>
              <div
                class="flex justify-between"
              >
                <div class="text-black flex items-center">
                  <strong class="text-md font-semibold">Nominal</strong>
                  <strong class="text-primary">*</strong>
                </div>
                <div
                  id="popover-topup"
                  class="text-[#0F679A] bg-[#DFF3FF]  rounded-[4px] p-[4px] flex gap-[4px] items-center"
                >
                  <div class="text-[12px]">
                    Auto Top Up
                  </div>
                  <span class="k-info-circle-1 text-[15px]" />
                </div>
                <BPopover
                  triggers="hover"
                  target="popover-topup"
                  placement="top"
                >
                  <div class="text-[#333333] text-[14px] font-semibold">
                    Auto Top-Up Komcards
                  </div>
                  <p class="mt-[7px] text-[12px]">
                    Nikmati kemudahan top-up otomatis ke Komcards, dan
                    <span
                      class="text-[#08A0F7] cursor-pointer"
                      @click="goToTopup"
                    >
                      Aktifkan Sekarang
                    </span>
                  </p>

                </BPopover>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Nominal"
              :rules="`required|minAmountTopup:${minTopupAmount}|maxAmountTopup:${balance}`"
            >
              <BFormInput
                v-model="nominal"
                :placeholder="'Minimal Top Up Rp 20.000'"
                :state="errors.length > 0 || limit_saldo_ideal ? false : null"
                @keypress="isNumber($event)"
                @input="formatCurrency"
              />
              <small
                v-if="errors.length > 0"
                class="text-danger"
              >{{ errors[0] }}</small>
              <small
                v-else-if="limit_saldo_ideal"
                class="text-danger"
              >
                Kamu memiliki Saldo Ideal {{ dataBalanceAnalitycs.ideal_balance.toLocaleString('id-ID') }} (min. saldo KomPay Rp {{ (Number(nominal.replace(/[^0-9]/g, '')) + dataBalanceAnalitycs.ideal_balance).toLocaleString('id-ID') }})
              </small>
            </ValidationProvider>
            <BCol
              v-if="limit_saldo_ideal"
              class="justify-between p-0 mt-[5px]"
            >
              <p class="mb-1 text-danger">
                Maksimal Top Up : <b>{{ IDR(max_topup_balance) }}</b>
              </p>
              <BCol class="flex flex-row justify-between p-0 mb-[15px]">
                <div class="text-black text-md">
                  {{ 'Saldo Kompay' }}
                </div>
                <div class="text-black text-md font-semibold">
                  {{ IDR(balance) }}
                </div>
              </BCol>
              <div class="bg-[#FFEDED] p-1 rounded-lg">
                <div class="d-flex mb-[8px]">
                  <span class="k-info-circle-1 text-danger font-bold align-content-center mr-[10px] text-xl" />
                  <div class="font-medium text-black text-[14px] align-content-center">
                    Batas Minimal Saldo Ideal : <b>Rp {{ dataBalanceAnalitycs.ideal_balance.toLocaleString('id-ID') }}</b>
                  </div>
                </div>
                <div class="mb-[8px]">
                  Saldo ideal diterapkan untuk menghindari saldo minus. <a
                    class="text-[#08A0F7] underline"
                    href="https://bantuan.komerce.id/id/article/saldo-ideal-komship-7dn9vp/?bust=1724821138075"
                    target="_blank"
                  >Pelajari lebih lanjut</a>
                </div>
                <div class="p-1 bg-[#FFFFFF]">
                  <div class="d-flex mb-[8px]">
                    <span class="k-message-question font-bold align-content-center mr-[10px] text-lg" />
                    <div class="font-medium align-content-center">
                      Darimana Saldo Ideal berasal ?
                    </div>
                  </div>
                  <span>Potensi Pendapatan Order Dikirim <b>Rp {{ dataBalanceAnalitycs.income_order_potential.toLocaleString('id-ID') }}</b> - Ongkir Retur Ketika Sampai <b>Rp {{ dataBalanceAnalitycs.ongkir_retur_on_finished.toLocaleString('id-ID') }}</b> - Resiko Ongkir Menjadi Retur <b>Rp {{ dataBalanceAnalitycs.ongkir_risk_become_retur.toLocaleString('id-ID') }}</b> =
                    Saldo Ideal <b class="text-danger">Rp {{ dataBalanceAnalitycs.ideal_balance.toLocaleString('id-ID') }}</b></span>
                </div>
              </div>
            </BCol>
            <BCol
              v-else
              class="flex flex-row justify-between p-0 mt-[5px]"
            >
              <div class="text-black text-md">
                Saldo Kompay
              </div>
              <div class="text-black text-md font-semibold">
                {{ IDR(balance) }}
              </div>
            </BCol>
          </BFormGroup>
          <BCol class="flex flex-row gap-4 justify-center mt-1">
            <BButton
              variant="outline-primary"
              @click="onBack"
            >
              Kembali
            </BButton>
            <BButton
              :variant="invalid || loading.possible || limit_saldo_ideal ? 'secondary' : 'primary'"
              type="submit"
              :disabled="invalid || loading.possible || limit_saldo_ideal"
              @click="checkPossibility"
            >
              <BSpinner
                v-if="loading.possible"
                variant="light"
                small
              />
              Top Up Sekarang
            </BButton>
          </BCol>
        </ValidationObserver>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { isNumber } from '@/libs/helpers'
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import { required } from '@validations'
import isNaN from 'lodash/isNaN'

extend('minAmountTopup', {
  params: ['min'],
  message: (_, values) => `Minimal ${IDR(values.min, 0, 2)}`,
  validate(value, args) {
    const min = typeof args === 'object' ? args.min : args[0]
    const numericValue = parseInt(value.toString().replace(/\D/g, ''), 10)
    return numericValue >= parseInt(min, 10)
  },
})

extend('maxAmountTopup', {
  params: ['max'],
  message: (_, values) => 'Maaf saldo anda tidak mencukupi',
  validate(value, args) {
    const max = typeof args === 'object' ? args.max : args[0]
    const numericValue = parseInt(value.toString().replace(/\D/g, ''), 10)
    return numericValue <= parseInt(max, 10)
  },
})

export default {
  components: { ValidationProvider, ValidationObserver },
  props: {
    cardData: {
      type: Object,
      default: () => ({}),
    },
    balance: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isNumber,
      required,
      IDR,
      user: this.$store.state.auth.userData,
      nominal: '',
      loading: {
        possible: false,
      },
      dataBalanceAnalitycs: {},
      max_topup_balance: 0,
      limit_saldo_ideal: false,
      realCardBalance: 0,
    }
  },
  computed: {
    minTopupAmount() {
      const balance = this.realCardBalance || 0
      let numericBalance = 0

      if (typeof balance === 'number') {
        numericBalance = Number.isNaN(balance) ? 0 : balance
      } else if (typeof balance === 'string') {
        let cleanBalance = balance.trim()
        if (cleanBalance.includes(',') && cleanBalance.includes('.')) {
          if (cleanBalance.lastIndexOf(',') > cleanBalance.lastIndexOf('.')) {
            cleanBalance = cleanBalance.replace(/\./g, '').replace(',', '.')
          } else {
            cleanBalance = cleanBalance.replace(/,/g, '')
          }
        } else if (cleanBalance.includes(',')) {
          cleanBalance = cleanBalance.replace(',', '.')
        }
        cleanBalance = cleanBalance.replace(/[^0-9.-]/g, '')
        numericBalance = parseFloat(cleanBalance) || 0
      }

      return Math.max(20000, 10000 - numericBalance)
    },
  },
  methods: {
    async onShow() {
      this.realCardBalance = this.cardData.balance || 0
      try {
        const url = '/komcards/api/v1/card/balance-cards'
        const res = await newAxiosIns.request({
          method: 'post',
          data: { card_ids: [this.cardData.id] },
          url,
        })
        this.realCardBalance = res.data.data[0].balance
      } catch (err) {
        console.error('Failed to fetch modal card balance:', err)
      }
    },
    goToTopup() {
      const route = this.$router.resolve({ name: 'payment-setting' })
      window.open(route.href, '_blank')
    },
    async checkPossibility() {
      if (this.user.is_komcards && !this.user.is_komship && !this.user.is_kompack) {
        this.$bvModal.show('modal-verify-pin')
        this.updateInput()
        return
      }

      if ((this.user.is_komcards && this.user.is_komship) || !this.user.is_kompack) {
        this.loading.possible = true
        const partner_id = this.user.partner_detail.id
        const url = `/komship/api/v1/admin/partner-consumables/balance-analitycs/${partner_id}`

        await newAxiosIns.get(url).then(res => {
          const { data } = res.data
          this.loading.possible = false
          this.dataBalanceAnalitycs = data
          const normalizeNominal = Number(this.nominal.replace(/[^0-9]/g, ''))
          this.max_topup_balance = Math.floor(normalizeNominal - data.ideal_balance)

          const potential_last_balance = this.balance - normalizeNominal
          if (potential_last_balance >= data.ideal_balance) {
            this.$bvModal.show('modal-verify-pin')
            this.updateInput()
          } else {
            this.limit_saldo_ideal = true
          }
        })
          .catch(() => {
            this.loading.possible = false
          })
      } else {
        this.$bvModal.show('modal-verify-pin')
        this.$bvModal.hide('modal-topup')
        this.updateInput()
      }
    },
    formatCurrency(value) {
      this.limit_saldo_ideal = false
      const newValue = Number(value.replace(/\D/g, ''))
      this.nominal = isNaN(newValue) ? value : IDR(newValue)
    },
    updateInput() {
      this.$emit('update-nominal-topup', this.nominal)
    },
    onBack() {
      this.$bvModal.hide('modal-topup')
      this.nominal = ''
    },
    onReset() {
      this.nominal = ''
    },
  },
}
</script>
